/** Query parameters are optional because authentication is carried by cookie. */
export const isOAuthCallbackPath = (pathname: string): boolean =>
  pathname === '/auth/callback';
